// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChevronSmallRightDoubleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ChevronSmallRightDoubleIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M6.244 5.75 10.49 10l-4.246 4.25-1.062-1.062L8.367 10 5.182 6.813z" />
      <path d="M11.386 5.75 15.632 10l-4.246 4.25-1.062-1.062L13.51 10l-3.185-3.187z" />
    </SvgIcon>
  );
});

/**
 * Use to expand the sidebar
 * @public
 */
export const ChevronSmallRightDoubleIcon = /* @__PURE__ */ Object.assign(
  ChevronSmallRightDoubleIconComponent,
  { displayName: 'ChevronSmallRightDoubleIcon' },
);
